import * as React from "react";
import { useRouter } from "@tanstack/react-router";
import { Text } from "../../../../ui/components/Text";
import { Button } from "../../../../ui/components/Button";

export function NotFoundPage() {
  const router = useRouter();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
        padding: "40px 24px",
        background: "var(--color-bg)",
      }}
    >
      {/* Large 404 */}
      <div
        style={{
          fontSize: 96,
          fontWeight: 800,
          lineHeight: 1,
          color: "var(--color-border)",
          letterSpacing: "-0.04em",
          marginBottom: 16,
          userSelect: "none",
        }}
      >
        404
      </div>

      <Text level="h2" weight="bold" style={{ marginBottom: 8, textAlign: "center" }}>
        Page not found
      </Text>

      <Text
        level="body-medium"
        color="muted"
        style={{ marginBottom: 28, textAlign: "center", maxWidth: 380 }}
      >
        The page you're looking for doesn't exist or may have been moved.
      </Text>

      <div style={{ display: "flex", gap: 10 }}>
        <Button type="button" color="neutral" onClick={() => router.history.back()}>
          Go back
        </Button>
        <Button
          type="button"
          color="primary"
          onClick={() => router.navigate({ to: "/" })}
        >
          Go home
        </Button>
      </div>
    </div>
  );
}
